export var VariableValueType;
(function (VariableValueType) {
    VariableValueType[VariableValueType["Constant"] = 0] = "Constant";
    VariableValueType[VariableValueType["Variable"] = 1] = "Variable";
})(VariableValueType || (VariableValueType = {}));
